module.exports = __webpack_public_path__ + "img/blik.af43c12.svg";